var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImgLogoReels = function SvgImgLogoReels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.166 18.675c1.299.584 2.764 1.242 4.28 2.149 2.884 1.725 5.773 4.286 5.834 8.5.105 7.2-6.194 8.914-12.076 8.926-4.335.01-12.416-1.227-12.485-6.855-.027-2.18 1.564-4.7 4.788-4.7 2.793 0 3.615 1.622 3.631 2.967.006.462-.097.897-.283 1.286a4.012 4.012 0 0 0-.522 2.148c.085 2.9 2.765 3.731 4.865 3.727 2.449-.006 4.696-1.345 4.657-4.03-.033-2.345-2.013-4.65-5.763-6.133-3.949-1.56-10.494-4.148-10.556-9.185-.053-4.292 2.711-7.725 11.78-7.725 2.433 0 4.112.53 5.634 1.01.933.295 1.806.571 2.757.695 1.398.236 2.38.204 2.876.185l-2.941 6.376s-1.775-6.973-8.308-6.812c-1.695.042-3.139 1.287-3.117 2.841.036 2.424 2.09 3.347 4.949 4.63Z",
    fill: "#fff"
  })));
};
export default SvgImgLogoReels;